module.exports = __webpack_public_path__ + "x2.no2.64dfeb6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/x2.no2.jpg
// module id = ToG6
// module chunks = 0